import React, { useEffect, useRef, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';

import staff_img from '../../../../images/staff/staff_1.png';
import axios from 'axios';
const ViewSubscription = ({ show, onClose, selectedId  }) => {

    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [data, setData] = useState([]);
    const [productrelation, setProdRel] = useState([]);
    const [timelinerelation, settimeline] = useState([]);
    const [subscriber, setSubscriber] = useState(null);
    const fetchData = () => {
        axios.get(`${baseURL}/leadsubscription/${selectedId}`)
            .then(response => {
                setData(response.data.data);
                setProdRel(response.data.data.productrelation);
                settimeline(response.data.data.timelinerelation);
                setSubscriber(response.data.data.subscriber);
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
            });
    };

    useEffect(() => {
        fetchData();
    }, []);

    const [complaintData, setComplaintdata] = useState([]);
    const [complaints, setComplaints] = useState([]);
    const [hasFetchedComplaints, setHasFetchedComplaints] = useState(false);
    const [convo, setconvo] = useState({ conversation: [] });

    const fetchcomplaint = () => {
        axios.get(`${baseURL}/complaint/subscribers/${subscriber}`)
            .then(response => {
                setComplaintdata(response.data.data);
                setHasFetchedComplaints(true);
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
                setHasFetchedComplaints(true);
            });
    }

    // fetch data & leadstatus
    useEffect(() => {
        if (subscriber) {
            fetchcomplaint();
        }
    }, [subscriber]);

    useEffect(() => {
        if (complaintData.length > 0) {
            const firstComplaint = complaintData[0]?.complaint;
            // const complaintMeta = complaintData[0];

            let conversation = [];

            // Try to parse stored conversation
            if (firstComplaint?.conversation) {
                try {
                    conversation = JSON.parse(firstComplaint.conversation);
                } catch (e) {
                    console.warn("Failed to parse conversation JSON", e);
                }
            }

            // // If conversation is empty, populate manually
            // if (conversation.length === 0) {
            //     conversation.push({
            //         complaint_type: complaintMeta.c_type_name || "Complaint",
            //         complaint: firstComplaint.complaint,
            //         datetime: firstComplaint.datetime,
            //     });

            //     if (firstComplaint.reason) {
            //         conversation.push({
            //             reason: firstComplaint.reason,
            //             reason_provider_name: firstComplaint.reason_provider_name,
            //             reason_datetime: firstComplaint.reason_datetime
            //         });
            //     }
            // }

            setconvo({ conversation });
        }
    }, [complaintData]);


    function formatTime(timeStr) {
        if (timeStr){
            const [hours, minutes] = timeStr.split(':');
            const date = new Date();
            date.setHours(parseInt(hours));
            date.setMinutes(parseInt(minutes));
            return date
                .toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true })
                .toUpperCase();  // Force AM/PM to uppercase
        } else {
            return '';
        }
    }

    const formatDate = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };

    const chatScrollRef = useRef(null);

    useEffect(() => {
        if (chatScrollRef.current) {
            chatScrollRef.current.scrollTop = chatScrollRef.current.scrollHeight;
        }
    }, []);

    return (
        <Modal show={show} size="xl"  >
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">View Subscription</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-6">
                            <label className='mb-0 font-w600 fs-4 text-red mb-3'>Subscriber Information</label>
                            <div className='d-flex flex-column'>
                                <div className='row'>
                                    <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                        <label className='text-gray-800 font-w500 fs-7'>Subscriber</label>
                                        <label className='text-black fs-6 font-w500'>{data.lead_name}</label>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                        <label className='text-gray-800 font-w500 fs-7'>Mobile No</label>
                                        <label className='text-black fs-6 font-w500'>{data.lead_mobile_no}</label>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                        <label className='text-gray-800 font-w500 fs-7'>Area</label>
                                        <label className='text-black fs-6 font-w500'>{data.area_name}</label>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                        <label className='text-gray-800 font-w500 fs-7'>Delivery Point</label>
                                        <label className='text-black fs-6 font-w500'>{data.deliverypoint_name}</label>
                                    </div>
                                    <div className='col-lg-8 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                        <label className='text-gray-800 font-w500 fs-7'>Email ID</label>
                                        <label className='text-black fs-6 font-w500'>{data.lead_email_id ? data.lead_email_id : '-'}</label>
                                    </div>
                                    <div className='col-lg-12 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                        <label className='text-gray-800 font-w500 fs-7'>Address</label>
                                        <label className='text-black fs-6 font-w500'>{data.address ? data.address : '-'}</label>
                                    </div>
                                </div>
                                <div className='rounded border border-gray'>
                                    <div className='text-center mb-0'>
                                        <div className="bg-danger-light border-bottom text-black font-w600 fs-3">
                                            <label className='mb-0'>Conversation</label>
                                        </div>
                                    </div>
                                    {convo.conversation && convo.conversation.length > 0 ? (
                                        <div className='scroll-y min-h-300px mh-300px px-3 py-2' ref={chatScrollRef} id="chat_scroll">
                                            {convo.conversation.map((item, index) => {
                                                const isComplaint = !!item.complaint;
                                                const isEven = index % 2 === 0;
            
                                                // Common formatting
                                                const datetime = new Date(item.datetime || item.reason_datetime).toLocaleString("en-GB", {
                                                    day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit',
                                                    hour12: true
                                                });
            
                                                const date = new Date(item.datetime || item.reason_datetime).toLocaleString("en-GB", {
                                                    day: '2-digit', month: 'short', year: 'numeric'
                                                });
            
                                                return (
                                                    <>
                                                        <div className="d-flex justify-content-center align-items-start mb-3">
                                                            <div className="px-3 py-0 rounded fw-semibold text-start bg-gray-300">
                                                                <div className="d-flex align-items-center">
                                                                    <label className="fs-8 font-w400 text-gray-800">{date}</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className={`d-flex ${isComplaint ? 'justify-content-start' : 'justify-content-end'} mb-3`} key={index}>
                                                            <div className={`d-flex flex-column mw-50 ${isComplaint ? 'align-items-start' : 'align-items-end'}`}>
                                                                <div className={`px-2 py-1 rounded border ${isComplaint ? 'bg-danger-light text-danger border-danger text-start msg_recv' : 'bg-info-light text-info border-info msg_send'}`}>
                                                                    {isComplaint && (
                                                                    <>
                                                                        <div className="d-block fs-8 font-w600 text-center"><u>{item.complaint_type || 'Complaint'}</u></div>
                                                                        <div className="fs-8 font-w400 mb-1 text-black">{item.complaint}</div>
                                                                        <div className="border-bottom border-danger"></div>
                                                                        <div className="d-block fs-9 font-w400 text-end text-black">{datetime}</div>
                                                                    </>
                                                                    )}
                                                                    {!isComplaint && (
                                                                    <>
                                                                        <div className='d-flex align-items-center mb-2'>
                                                                        {item.image ? (
                                                                            <img src={item.image} alt="Resolved Person" className='cursor-pointer rounded-pill w-35px h-35px' />
                                                                        ):(
                                                                            <img src={staff_img} alt="Resolved Person" className='cursor-pointer rounded-pill w-35px h-35px' />
                                                                        )}
                                                                        <div className='ms-1'>
                                                                            <div className='text-info font-w400 fs-7'>{item.reason_provider_name}</div>
                                                                            <div className="d-block fs-9 font-w400 text-end text-black">{datetime}</div>
                                                                        </div>
                                                                        </div>
                                                                        <div className="border-bottom border-info mb-1"></div>
                                                                        <div className="fs-8 font-w400 mb-1 text-black">{item.reason}</div>
                                                                    </>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {!isComplaint && (
                                                            <div className="border-bottom my-2"></div>
                                                        )}
                                                    </>
                                                );
                                            })}
                                        </div>
                                    ) : (
                                        <div className="text-center text-muted py-5">
                                            <span className="fs-7">No conversation available</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <label className='mb-0 font-w600 fs-4 text-red mb-3'>Product Information</label>
                            <div className='d-flex flex-column'>
                                <div className='row'>
                                    <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                        <label className='text-gray-800 font-w500 fs-7'>Product</label>
                                        <label className='text-black fs-6 font-w500'>{data.product_name}</label>
                                    </div>
                                    <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                        <label className='text-gray-800 font-w500 fs-7'>Timeline</label>
                                        <label className='text-black fs-6 font-w500'>{data.timeline_name} ({data.timeline_days} Days)</label>
                                    </div>
                                    <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                        <label className='text-gray-800 font-w500 fs-7'>Days</label>
                                        <label className='text-black fs-6 font-w500'>
                                        {timelinerelation.all_days === 0
                                            ? 'All'
                                            : [
                                                timelinerelation.monday === "0" && 'Mon',
                                                timelinerelation.tuesday === "0" && 'Tue',
                                                timelinerelation.wednesday === "0" && 'Wed',
                                                timelinerelation.thursday === "0" && 'Thu',
                                                timelinerelation.friday === "0" && 'Fri',
                                                timelinerelation.saturday === "0" && 'Sat',
                                                timelinerelation.sunday === "0" && 'Sun',
                                            ]
                                            .filter(Boolean)
                                            .join(', ')
                                        }
                                        </label>
                                    </div>
                                    <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                        <label className='text-gray-800 font-w500 fs-7'>Duration</label>
                                        <div className="font-w500 fs-6">
                                            <label className="text-success font-w500 fs-6">{formatDate(data.start_date)}</label>
                                            <label className="text-black font-w500 fs-6 ms-1 me-1">/</label>
                                            <label className="text-danger font-w500 fs-6">{formatDate(data.end_date)}</label>
                                        </div>
                                    </div>
                                    <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                        <label className='text-gray-800 font-w500 fs-7'>Service Time</label>
                                        <div className="font-w500 fs-6">
                                            <div className="font-w500 fs-6">
                                                <label className="text-success font-w500 fs-6">{formatTime(productrelation.delivery_start_time)}</label>
                                                <label className="text-black font-w500 fs-6 ms-1 me-1">/</label>
                                                <label className="text-danger font-w500 fs-6">{formatTime(productrelation.delivery_end_time)}</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                        <label className='text-gray-800 font-w500 fs-7'>Payment Mode</label>
                                        <label className='text-black fs-6 font-w500'>
                                        {data.payment_process === 0
                                            ? (
                                                <>
                                                {data.payment_mode_name} 
                                                {data.transaction_id && ` (${data.transaction_id})`}
                                                </>
                                            ) 
                                            : 'Pending'
                                        }
                                        </label>
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-4">
                                        <div className='badge bgl-warning py-2 px-3'>
                                            <div className="text-black font-w500 fs-7">Balance Orders</div>
                                            <div className='d-block text-warning font-w500 fs-5'>{data.balance_delivery}</div>
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div className='badge bgl-success py-2 px-3'>
                                            <div className="text-black font-w500 fs-7">Delivered Orders</div>
                                            <div className='d-block text-success font-w500 fs-5'>{data.delivered}</div>
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div className='badge bgl-info py-2 px-3'>
                                            <div className="text-black font-w500 fs-7">Total Orders</div>
                                            <div className='d-block text-info font-w500 fs-5'>{data.total_delivery}</div>
                                        </div>
                                    </div>
                                </div>
                                {data.hold_count > 0 && (
                                    <div className='row mt-2'>
                                        <label className='font-w600 fs-4 text-red mb-3'>Hold Days and its Reasons</label>
                                        <div className="col-lg-12">
                                            <div className='rounded border border-gray'>
                                                <div className='scroll-y min-h-150px mh-120px px-3 py-2'>
                                                    {JSON.parse(data.hold_details || '[]').map((item, index) => (
                                                        <React.Fragment key={index}>
                                                        <ul className='mb-2 d-flex flex-row gap-4'>
                                                            {item.date.map((dateStr, i) => {
                                                                // Convert date format from yyyy-mm-dd to dd-MMM-yyyy
                                                                const dateObj = new Date(dateStr);
                                                                const options = { day: '2-digit', month: 'short', year: 'numeric' };
                                                                const formattedDate = dateObj.toLocaleDateString('en-GB', options);

                                                                return (
                                                                <li key={i} className='text-black fs-6'>
                                                                    <i className="far fa-circle-check text-primary fs-4 me-2"></i>
                                                                    <span>{formattedDate}</span>
                                                                </li>
                                                                );
                                                            })}
                                                        </ul>
                                                        <p className='text-black fs-7 font-w500'>
                                                            &emsp;&emsp;{item.reason}
                                                        </p>
                                                        </React.Fragment>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {data.special_case && (
                                    <div className='row mt-2'>
                                        <label className='font-w600 fs-4 text-red mb-3'>Special Case</label>
                                        <div className="col-lg-12">
                                            <div className='rounded border border-gray'>
                                                <div className='scroll-y min-h-125px mh-120px px-3 py-2'>
                                                    {(typeof data.special_case === 'string' 
                                                        ? JSON.parse(data.special_case || '[]') 
                                                        : data.special_case || []
                                                    ).map((item, index) => (
                                                        <div key={index}>
                                                            <label className='text-black fs-7 font-w500 mb-2'>
                                                                {item.item_name}
                                                                {item.is_replace ? ` Replaced to ${item.replace_item_name}` : ' Neglected'}
                                                            </label>
                                                        </div>
                                                    ))}

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default ViewSubscription;
